// Listing status types
export const LISTING_STATUS = {
  ACTIVE: 'Active',
  PENDING: 'Pending',
  CLOSED: 'Closed',
};

// Example listing data structure (to be replaced with Spark API data)
export const exampleListings = [
  // {
  //   id: '1',
  //   status: LISTING_STATUS.CLOSED,
  //   closeDate: '2024-12-15',
  //   price: 750000,
  //   address: '123 Main St, Denver, CO',
  //   beds: 3,
  //   baths: 2,
  //   sqft: 2100,
  //   photos: ['url1', 'url2'],
  //   agentRole: 'Listing', // or 'Buyside'
  //   yearClosed: 2024,
  //   ...
  // },
];
